import { observer } from 'src/utils/mobx-react';
import { useAsObservableSource } from 'mobx-react-lite';
import React, { ChangeEvent, useState } from 'react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { action, makeAutoObservable } from 'mobx';
import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';
import { validateNotEmpty } from 'src_common/common/mobx-utils/Form2/validators';

class InputState {
    public readonly inputState: FormInputState<string | null, string | null>;

    constructor(private readonly props: InputPropsType) {
        this.inputState = FormInputState.new(props.value).map((value): Result<string | null> => {
            if (value !== null) {
                return validateNotEmpty('Market name is required')(value);
            }

            return Result.createOk(value);
        });
        makeAutoObservable(this);
    }

    @action onBlur = (): void => {
        this.inputState.setAsVisited();
    };

    @action onValueChange = (event: ChangeEvent<HTMLInputElement>): void => {
        this.inputState.setValue(event.target.value);
    };

    @action onSaveHandler = (): void => {
        if (this.inputState.errorsForView.length > 0) {
            console.warn('Value from input can not be save. Input has some errors');
            return;
        }

        if (this.inputState.value !== null) {
            this.props.onSave(this.inputState.value);
            this.inputState.reset();
            console.log('current props value', this.props.value);
            this.inputState.setValue(null);
        }
    };
}

export type InputPropsType = {
    dataTest: string;
    label: string;
    name: string;
    value: string | null;
    onSave: (value: string) => void;
};

export const MarketName = observer('MarketName', (propsIn: InputPropsType) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new InputState(props));
    const isValidInput =
        state.inputState.isVisited() === true ? (state.inputState.errorsForView.length > 0 ? 'invalid' : 'valid') : '';

    return (
        <>
            <div className='col-8'>
                <div
                    className={`element required hasLabel ${isValidInput}`}
                    data-test={props.dataTest}
                >
                    <input
                        type='text'
                        data-test='market-name-input'
                        name={props.name}
                        value={state.inputState.value !== null ? state.inputState.value : props.value ?? ''}
                        onChange={state.onValueChange}
                        onBlur={state.onBlur}
                    />
                    <label>{props.label}</label>
                    {isValidInput === 'invalid' ? (
                        <div className='error-message'>
                            <div className='error-message-content'>This field is required.</div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className='col-4'>
                <button
                    type='button'
                    className='btn'
                    data-test='save-market-name-button'
                    onClick={state.onSaveHandler}
                >
                    Save name
                </button>
            </div>
        </>
    );
});
